import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "facebook-square-brands",
  "use": "facebook-square-brands-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"facebook-square-brands\"><path d=\"M21.429 0H2.57A2.571 2.571 0 000 2.571V21.43A2.571 2.571 0 002.571 24h7.353v-8.16H6.55V12h3.375V9.073c0-3.33 1.982-5.169 5.018-5.169 1.454 0 2.974.26 2.974.26V7.43h-1.675c-1.65 0-2.165 1.025-2.165 2.075V12h3.684l-.589 3.84h-3.095V24h7.353A2.57 2.57 0 0024 21.429V2.57A2.571 2.571 0 0021.429 0z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol